import Typography from "@mui/material/Typography"

import Column from "./Column"

export default function TitledSection({
  title,
  children,
  variant = "h6",
  gap = 2,
}) {
  return (
    <Column gap={gap}>
      <Typography variant={variant}>{title}</Typography>
      {children}
    </Column>
  )
}
